import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    position: 'relative',
    padding: theme.spacing(1),
    "& .MuiCardContent-root:last-child": {
      paddingBottom: 16,
    },
  },
  title: {
    fontSize: 14,
    marginTop: 30,
  },
  rounded: {
    color: '#fff',
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

export default useStyles;
